module.exports = "<ng-template>\n    <ng-content></ng-content>\n  </ng-template>"


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/list-view/list-item/list-item.component.html
// module id = ../../../../../src/app/@hornbillfx/components/list-view/list-item/list-item.component.html
// module chunks = main